import request from "../utils/request";

export function getAllCostType() {
    return request({
        url: "cost-type",
        method: "get",
    });
}